// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompleteEvaluationWizard .Modal-Dialog .Modal-Content {
  padding: 0;
}
.CompleteEvaluationWizard .Modal-Dialog .Modal-Content .Modal-Body {
  padding: 0;
}
.CompleteEvaluationWizard .Form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.CompleteEvaluationWizard .Form > * {
  padding-left: 3rem !important;
  padding-right: 3rem !important;
}
.CompleteEvaluationWizard-ProgressHeader {
  padding-top: 2.67rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(var(--bs-primary-rgb) 0.1);
  box-shadow: 3px 4px 12px -2px rgba(0, 0, 0, 0.1);
}
.CompleteEvaluationWizard-ProgressBar {
  --bs-progress-height: 0.4rem;
  --bs-progress-bg: #f6f7f9;
  width: 100%;
  border-radius: var(--bs-border-radius-pill);
  border: 1px solid var(--bs-primary);
}
.CompleteEvaluationWizard-ProgressBar > .progress-bar {
  --bs-progress-bar-bg: var(--bs-primary);
}
.CompleteEvaluationWizard-Step {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.CompleteEvaluationWizard-SectionHeader {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.CompleteEvaluationWizard-SectionHeader p {
  margin: 0;
}
.CompleteEvaluationWizard-SectionIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  font-size: 1.5rem;
  padding: 0.75rem;
}
.CompleteEvaluationWizard-SectionIcon-Notes {
  background-color: #f3e8ff;
}
.CompleteEvaluationWizard-SectionIcon-Completion {
  background-color: #e0e7ff;
}
.CompleteEvaluationWizard-Label {
  margin: 0 0 0.5rem;
  color: var(--bs-primary);
  letter-spacing: 0.06em;
  font-weight: 700;
  text-transform: uppercase;
}
.CompleteEvaluationWizard-Field {
  margin: 0;
}
.CompleteEvaluationWizard-HelperText {
  margin: 0;
}
.CompleteEvaluationWizard-Summary {
  background-color: #f9fafc;
  border-radius: 4px;
  padding: 1rem 1.25rem;
}
.CompleteEvaluationWizard-Summary-Row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 2rem;
  margin-bottom: 0.5rem;
}
.CompleteEvaluationWizard-Summary-Row:last-child {
  margin-bottom: 0;
}
.CompleteEvaluationWizard-Summary-Row strong {
  color: var(--bs-primary);
}
.CompleteEvaluationWizard-Summary-Key {
  color: #808080;
  margin-right: 0.5rem;
}
.CompleteEvaluationWizard-Certification {
  margin: 0;
  color: var(--bs-primary);
  font-weight: 700;
}
.CompleteEvaluationWizard-Notice {
  background-color: #eff6ff;
  border: 1px solid #bfdfff;
  border-radius: 4px;
  padding: 0.75rem 1rem;
}
.CompleteEvaluationWizard-Notice p {
  color: var(--bs-primary);
  margin: 0;
}
.CompleteEvaluationWizard-Footer {
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 6.42rem;
  gap: 0.75rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 3px -4px 12px -2px rgba(0, 0, 0, 0.1);
}
.CompleteEvaluationWizard .OverallResultPills {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  margin: 0;
}
.CompleteEvaluationWizard .OverallResultPills.Field.Common[data-feedback]:after {
  bottom: -0.3rem;
}
.CompleteEvaluationWizard .OverallResultPills-Pill {
  width: auto;
  flex: 1 1 0;
  border-radius: var(--bs-border-radius-pill);
  font-weight: 700;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1), 4px 6px 6px 0 rgba(0, 0, 0, 0.06);
}
.CompleteEvaluationWizard .OverallResultPills-Pill-Checked, .CompleteEvaluationWizard .OverallResultPills-Pill:hover {
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25) inset;
  background-color: rgba(var(--bs-gray-subtle-rgb), 0.15);
}`, "",{"version":3,"sources":["webpack://./src/pages/Users/components/CompleteEvaluationWizard/styles.scss"],"names":[],"mappings":"AAEI;EACE,UAAA;AADN;AAEM;EACE,UAAA;AAAR;AAKE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAHJ;AAKI;EACE,6BAAA;EACA,8BAAA;AAHN;AAOE;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,SAAA;EACA,oBAAA;EACA,wDAAA;EACA,gDAAA;AALJ;AAQE;EACE,4BAAA;EACA,yBAAA;EACA,WAAA;EACA,2CAAA;EACA,mCAAA;AANJ;AASI;EACE,uCAAA;AAPN;AAWE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AATJ;AAYE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAVJ;AAYI;EACE,SAAA;AAVN;AAcE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AAZJ;AAcI;EACE,yBAAA;AAZN;AAeI;EACE,yBAAA;AAbN;AAiBE;EACE,kBAAA;EACA,wBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;AAfJ;AAkBE;EACE,SAAA;AAhBJ;AAmBE;EACE,SAAA;AAjBJ;AAoBE;EACE,yBAAA;EACA,kBAAA;EACA,qBAAA;AAlBJ;AAoBI;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAlBN;AAoBM;EACE,gBAAA;AAlBR;AAqBM;EACE,wBAAA;AAnBR;AAuBI;EACE,cAAA;EACA,oBAAA;AArBN;AAyBE;EACE,SAAA;EACA,wBAAA;EACA,gBAAA;AAvBJ;AA0BE;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AAxBJ;AA0BI;EACE,wBAAA;EACA,SAAA;AAxBN;AA4BE;EACE,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,wCAAA;EACA,iDAAA;AA1BJ;AA6BE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;AA3BJ;AA6BI;EACE,eAAA;AA3BN;AA8BI;EACE,WAAA;EACA,WAAA;EACA,2CAAA;EACA,gBAAA;EACA,6EACE;AA7BR;AAgCM;EAEE,iDAAA;EACA,uDAAA;AA/BR","sourcesContent":[".CompleteEvaluationWizard {\n  .Modal-Dialog {\n    .Modal-Content {\n      padding: 0;\n      .Modal-Body {\n        padding: 0;\n      }\n    }\n  }\n\n  .Form {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n\n    > * {\n      padding-left: 3rem !important;\n      padding-right: 3rem !important;\n    }\n  }\n\n  &-ProgressHeader {\n    padding-top: 2.67rem;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: center;\n    gap: 1rem;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid rgba(var(--bs-primary-rgb) 0.1);\n    box-shadow: 3px 4px 12px -2px rgba(0, 0, 0, 0.1);\n  }\n\n  &-ProgressBar {\n    --bs-progress-height: 0.4rem;\n    --bs-progress-bg: #f6f7f9;\n    width: 100%;\n    border-radius: var(--bs-border-radius-pill);\n    border: 1px solid var(--bs-primary);\n\n    // inner fill style\n    > .progress-bar {\n      --bs-progress-bar-bg: var(--bs-primary);\n    }\n  }\n\n  &-Step {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n\n  &-SectionHeader {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n\n    p {\n      margin: 0;\n    }\n  }\n\n  &-SectionIcon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0.75rem;\n    font-size: 1.5rem;\n    padding: 0.75rem;\n\n    &-Notes {\n      background-color: #f3e8ff;\n    }\n\n    &-Completion {\n      background-color: #e0e7ff;\n    }\n  }\n\n  &-Label {\n    margin: 0 0 0.5rem;\n    color: var(--bs-primary);\n    letter-spacing: 0.06em;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n\n  &-Field {\n    margin: 0;\n  }\n\n  &-HelperText {\n    margin: 0;\n  }\n\n  &-Summary {\n    background-color: #f9fafc;\n    border-radius: 4px;\n    padding: 1rem 1.25rem;\n\n    &-Row {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 0.5rem 2rem;\n      margin-bottom: 0.5rem;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      strong {\n        color: var(--bs-primary);\n      }\n    }\n\n    &-Key {\n      color: #808080;\n      margin-right: 0.5rem;\n    }\n  }\n\n  &-Certification {\n    margin: 0;\n    color: var(--bs-primary);\n    font-weight: 700;\n  }\n\n  &-Notice {\n    background-color: #eff6ff;\n    border: 1px solid #bfdfff;\n    border-radius: 4px;\n    padding: 0.75rem 1rem;\n\n    p {\n      color: var(--bs-primary);\n      margin: 0;\n    }\n  }\n\n  &-Footer {\n    flex: 0 0 auto;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 6.42rem;\n    gap: 0.75rem;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n    box-shadow: 3px -4px 12px -2px rgba(0, 0, 0, 0.1);\n  }\n\n  .OverallResultPills {\n    display: flex;\n    flex-direction: row;\n    gap: 0.75rem;\n    margin: 0;\n\n    &.Field.Common[data-feedback]:after {\n      bottom: -0.3rem;\n    }\n\n    &-Pill {\n      width: auto;\n      flex: 1 1 0;\n      border-radius: var(--bs-border-radius-pill);\n      font-weight: 700;\n      box-shadow:\n        0 4px 4px 0 rgba(0, 0, 0, 0.1),\n        4px 6px 6px 0 rgba(0, 0, 0, 0.06);\n\n      &-Checked,\n      &:hover {\n        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25) inset;\n        background-color: rgba(var(--bs-gray-subtle-rgb), 0.15);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
